import React, { useState, useEffect } from 'react';
import {
  ChevronRightRounded,
  DriveFileRenameOutlineOutlined,
} from '@mui/icons-material';
import {
  Box,
  Container, Divider, IconButton, Stack,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { clearStorage, getUserData } from '../../../../Utils/storages';
import Elements from '../../../Elements';
import ROUTES from '../../../../Configs/routes';
import Images from '../../../../Configs/images';
import { getWallet, getUserData as getUser } from '../../../../Redux/Models/user';
// import Elements from '../../../Elements';

export default function Dev({ classes }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [logoutPop, setLogoutPop] = useState(false);
  const userData = getUserData() || {};
  const { t } = useTranslation();

  useEffect(() => {
    dispatch(getWallet(userData.id, {}));
    dispatch(getUser(userData.id));
  }, []);

  const toggleLogoutPop = () => {
    setLogoutPop(!logoutPop);
  };

  const role = userData?.role_id?.toLowerCase();
  const logout = () => {
    clearStorage();
    window.location.reload();
  };

  return (
    <div className={classes.root}>
      <Elements.Navigator title={t('profilePage.title')} />
      <Container>
        <div className="flex space-between mt-4">
          <div className="flex gap-8 align-items-center">
            {!!userData.profile_picture
            && (
            <Box>
              <img src={userData.profile_picture} alt="profile" width="42" height="42" className="circle cover" />
            </Box>
            )}
            <Stack direction="column" gap="2px">
              <div className="s-12 one-line weight-700">{userData.front_name || userData.username}</div>
              <div className="s-12">{userData.phone_number}</div>
              <div className="s-12">{userData.email}</div>
              {role === 'user'
              && (
              <div className="inline-block">
                <Box display="inline-flex" className="gap-4 class align-items-center">
                  <img height="24" src={userData.subscription === 'Business to Customer (B2C)' ? Images.IconSubscription : Images.PremiumStar} alt="star" />
                  <div className="weight-500 s-12 color-green">{userData.subscription}</div>
                </Box>
              </div>
              )}
            </Stack>
          </div>
          <div>
            <IconButton onClick={() => navigate('update')}>
              <DriveFileRenameOutlineOutlined className="color-green" />
            </IconButton>
          </div>
        </div>
      </Container>

      <Divider sx={{ borderWidth: 3, borderColor: '#F5F6F8', my: 2 }} />

      {role === 'user'
        && (
        <>
          <Container>
            <Box className="s-12 weight-700">{t('wallet.myBalance')}</Box>
            <Box p={1} borderRadius="4px" border="1px solid #F5F6F8" mt={1}>
              <Elements.Balance />
            </Box>
          </Container>
          <Divider sx={{ borderWidth: 3, borderColor: '#F5F6F8', my: 2 }} />
        </>
        )}

      <Container>
        <Box className="s-12 weight-700">{t('profilePage.accInfo')}</Box>
        <Box pt={2} display="flex" gap={1} onClick={() => navigate(ROUTES.address())}>
          <img src={Images.IconLocation} alt="address" width="18" height="18" />
          <Box flex={1}>
            <Box display="flex" justifyContent="space-between">
              <Box className="s-12 weight-600">{t('profilePage.address')}</Box>
              <ChevronRightRounded className="mute" />
            </Box>
            <Divider sx={{ mt: 0.5 }} />
          </Box>
        </Box>
        <Box pt={1.5} display="flex" gap={1}>
          <img src={Images.IconPrivacy} alt="privacy" width="18" height="18" />
          <Box flex={1}>
            <Box display="flex" justifyContent="space-between">
              <Box className="s-12 weight-600">{t('profilePage.accPrivacy')}</Box>
              <ChevronRightRounded className="mute" />
            </Box>
            <Divider sx={{ mt: 0.5 }} />
          </Box>
        </Box>
        <Box pt={1.5} display="flex" gap={1}>
          <img src={Images.IconSecurity} alt="security" width="18" height="18" />
          <Box flex={1}>
            <Box display="flex" justifyContent="space-between">
              <Box className="s-12 weight-600">{t('profilePage.accSecurity')}</Box>
              <ChevronRightRounded className="mute" />
            </Box>
            <Divider sx={{ mt: 0.5 }} />
          </Box>
        </Box>
        {role === 'user'
        && (
        <Box pt={1.5} display="flex" gap={1} onClick={() => navigate(userData.subscription ? ROUTES.mySubscription() : ROUTES.subscription())}>
          <img src={Images.IconSubscription} alt="subscription" width="18" height="18" />
          <Box flex={1}>
            <Box display="flex" justifyContent="space-between">
              <Box className="s-12 weight-600">{t('profilePage.mySub')}</Box>
              <ChevronRightRounded className="mute" />
            </Box>
            <Divider sx={{ mt: 0.5 }} />
          </Box>
        </Box>
        )}
      </Container>

      <Divider sx={{ borderWidth: 3, borderColor: '#F5F6F8', my: 2 }} />

      <Container>
        <Box className="s-12 weight-700">{t('profilePage.aboutOeno')}</Box>
        <Box pt={2} display="flex" gap={1} onClick={() => navigate(ROUTES.about())}>
          <img src={Images.IconOeno} alt="oeno bank" width="18" height="18" />
          <Box flex={1}>
            <Box display="flex" justifyContent="space-between">
              <Box className="s-12 weight-600">{t('profilePage.know')}</Box>
              <ChevronRightRounded className="mute" />
            </Box>
            <Divider sx={{ mt: 0.5 }} />
          </Box>
        </Box>
        <Box pt={2} display="flex" gap={1} onClick={() => navigate(ROUTES.termsConditions())}>
          <img src={Images.IconInfoRounded} alt="terms" width="18" height="18" />
          <Box flex={1}>
            <Box display="flex" justifyContent="space-between">
              <Box className="s-12 weight-600">{t('profilePage.tor')}</Box>
              <ChevronRightRounded className="mute" />
            </Box>
            <Divider sx={{ mt: 0.5 }} />
          </Box>
        </Box>
        <Box pt={2} display="flex" gap={1} onClick={() => navigate(ROUTES.privacyPolicy())}>
          <img src={Images.IconPolicy} alt="privacy policy" width="18" height="18" />
          <Box flex={1}>
            <Box display="flex" justifyContent="space-between">
              <Box className="s-12 weight-600">{t('profilePage.privacy')}</Box>
              <ChevronRightRounded className="mute" />
            </Box>
            <Divider sx={{ mt: 0.5 }} />
          </Box>
        </Box>
        <Box pt={2} display="flex" gap={1} onClick={() => navigate(ROUTES.helpCenter())}>
          <img src={Images.IconHelp} alt="help" width="18" height="18" />
          <Box flex={1}>
            <Box display="flex" justifyContent="space-between">
              <Box className="s-12 weight-600">{t('profilePage.help')}</Box>
              <ChevronRightRounded className="mute" />
            </Box>
            <Divider sx={{ mt: 0.5 }} />
          </Box>
        </Box>
        <Box pt={2} display="flex" gap={1} onClick={() => navigate(ROUTES.settings())}>
          <img src={Images.IconSettings} alt="settings" width="18" height="18" />
          <Box flex={1}>
            <Box display="flex" justifyContent="space-between">
              <Box className="s-12 weight-600">{t('profilePage.settings')}</Box>
              <ChevronRightRounded className="mute" />
            </Box>
            <Divider sx={{ mt: 0.5 }} />
          </Box>
        </Box>
        <Box pt={2} display="flex" gap={1} onClick={() => navigate(ROUTES.contactUs())}>
          <img src={Images.IconMail} alt="contact" width="18" height="18" />
          <Box flex={1}>
            <Box display="flex" justifyContent="space-between">
              <Box className="s-12 weight-600">{t('profilePage.contact')}</Box>
              <ChevronRightRounded className="mute" />
            </Box>
            <Divider sx={{ mt: 0.5 }} />
          </Box>
        </Box>
      </Container>

      <Divider sx={{ borderWidth: 3, borderColor: '#F5F6F8', my: 2 }} />

      <Container>
        <Box pt={2} display="flex" gap={1} onClick={toggleLogoutPop}>
          <img src={Images.IconSignout} alt="signout" width="18" height="18" />
          <Box flex={1}>
            <Box display="flex" justifyContent="space-between">
              <Box className="s-12 weight-600">{t('profilePage.signout')}</Box>
              <ChevronRightRounded className="mute" />
            </Box>
            <Divider sx={{ mt: 0.5 }} />
          </Box>
        </Box>
      </Container>

      <Divider sx={{ borderWidth: 3, borderColor: '#F5F6F8', my: 2 }} />

      <Elements.Footer />

      <Elements.ConfirmationModal
        open={logoutPop}
        desc={(<div className="center weight-700">Are you sure want to sign out?</div>)}
        handleClose={toggleLogoutPop}
        handleAgree={logout}
        confirmText="Sign out"
      />
    </div>
  );
}
